import script from "./LocaleSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=8d2f2184&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d2f2184"]])

export default __exports__